var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',[_vm._v("\n  "+_vm._s(_setup.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }